import { render } from "./WzCaseForm.vue?vue&type=template&id=3e61e575"
import script from "./WzCaseForm.vue?vue&type=script&lang=js"
export * from "./WzCaseForm.vue?vue&type=script&lang=js"

import "./WzCaseForm.vue?vue&type=style&index=0&id=3e61e575&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__